import type { FaireProductEntity } from "../../entity_types/product";

export const p_3kdrf453d8: FaireProductEntity = {
  token: "p_3kdrf453d8",
  type: "product",
  name: "AIR11 AIR SCUBA CROP TANK TOP & SHORT SETS",
  brandToken: "b_2gvr4jr26k",
  brandName: "MIO WHOLESALE",
  imageUrl:
    "https://cdn.faire.com/fastly/2633949da4c64d5e65ec6d1e6f1ae70f279e4c9137fa08003d87b3598a28c4f6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/604cee7e2b6d9b0acef657c24543c03d8f5137d07e0ae7d243675aa0f1bff441.jpeg",
    "https://cdn.faire.com/fastly/fca1ba816eca3b0470ca86c075c936cb52546e81b855bb50356483becdbcb93c.jpeg",
    "https://cdn.faire.com/fastly/45b558cc97e62071ae8e9efe77af9d2629731794d8fb1f4b889f2ddb66fef8a6.jpeg",
    "https://cdn.faire.com/fastly/b1818f6c5dd06da5c3cbf602514a481e7ba2674c6ba14b8b52eaf74bd21273fe.jpeg",
    "https://cdn.faire.com/fastly/cc9bb139b7c549c7e005e5213db86dff26e1c8554a0ebfbcfc55f93df7b2f60a.jpeg",
    "https://cdn.faire.com/fastly/f597245f9b1ac083cb0ad0670fbc27e9b7bea2a017da2d1eca262153a19ac7e8.jpeg",
    "https://cdn.faire.com/fastly/4e30015230668de6e09d5330bc060c240fc79df545d4ab2b04e1f7c97e84bcae.jpeg",
    "https://cdn.faire.com/fastly/4ffd44c7d755874f141b57c3cf1bc178bba01d81bf4b17b6909a3811f637b98c.jpeg",
    "https://cdn.faire.com/fastly/780d0d2a31d64d722e115b941ffb52c5dcf2e7db7da6d7c9a8b78aff1b7eb8c1.jpeg",
    "https://cdn.faire.com/fastly/168a01442a8b06b8b674de9e2a1cbc5b04a7075e9de0bcd75ec0efc4311791de.jpeg",
    "https://cdn.faire.com/fastly/d3fc0bc4cb3c55a894ba0938128c4cf0d6b00ead6de4920e72d38f4e2b9f7064.jpeg",
    "https://cdn.faire.com/fastly/f25840b9fccb59e928c626e9431c555065acbc278ac73badfe83734fd29008e1.jpeg",
    "https://cdn.faire.com/fastly/eba79f7a3947716eab0da018e59eab1bcda208241d7a29598e2810486a2e3254.jpeg",
    "https://cdn.faire.com/fastly/7be399d99b0b74216dc5b025550c564266ec3e97b6e5a8199a5adcc99f8dccad.jpeg",
    "https://cdn.faire.com/fastly/3ea07875b27eccbe68f3cdf43a9c5a70b357ca32ca34e868f662b800ba3f41c1.jpeg",
    "https://cdn.faire.com/fastly/9202b2f5faa2983ae9215f6ef5d1b3ef89d159603c71e52ac2477f0d05cdaeca.jpeg",
    "https://cdn.faire.com/fastly/7f2ecf48828c3e17657641fe639a58768be73b633b1d771e600a564aa12b981c.jpeg",
    "https://cdn.faire.com/fastly/6d60208b24b0408eebd4729862c1097d40f472ebc19c97102f96032efdce9f1c.jpeg",
    "https://cdn.faire.com/fastly/03a01aa2f8a2b1f0336d3bf061d9bb0c1ad37706681ccff324f428aaa016dab1.jpeg",
  ],
  priceDollars: 7.75,
  description:
    "Stretch Air Scuba Round Neck Crop Tank top & Drawstring Short Sets\nModel is wearing a size Small\nIn pack of 2S, 2M & 2L per color only.",
  tags: [],
  msrpDollars: 15.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:02.742Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
